/** Create by Marlon Reyes 15/07/2019 **/
const colors = {
    blueDark: '#007FC7',
    blueLight: '#00ADEF',
};

export default colors;